import { render } from "./ModalVideo.vue?vue&type=template&id=7fc4264b&scoped=true"
import script from "./ModalVideo.vue?vue&type=script&lang=ts"
export * from "./ModalVideo.vue?vue&type=script&lang=ts"

import "./ModalVideo.vue?vue&type=style&index=0&id=7fc4264b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fc4264b"

export default script